﻿// 独立共享模块：api 封装 + 全局作用域状态 + 用户身份（PRD 第四章三角色）
// （从 main.js 拆出，避免 App.vue ↔ main.js 循环引用导致挂载时 TDZ 问题）
export const api = {
  async get(url, params) {
    const q = params ? '?' + new URLSearchParams(Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== '')) : '';
    const r = await fetch(url + q);
    if (!r.ok) { const e = await r.json().catch(() => ({})); if (r.status === 401 && e.needLogin) needLogin(); throw new Error(e.error || r.statusText); }
    return r.json();
  },
  async post(url, body) {
    const r = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body || {}) });
    const d = await r.json().catch(() => ({}));
    if (!r.ok) { if (r.status === 401 && d.needLogin) needLogin(); throw new Error(d.error || r.statusText); }
    return d;
  },
  async put(url, body) {
    const r = await fetch(url, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body || {}) });
    const d = await r.json().catch(() => ({}));
    if (!r.ok) { if (r.status === 401 && d.needLogin) throw Object.assign(new Error(d.error || r.statusText), { needLogin: true }); throw new Error(d.error || r.statusText); }
    return d;
  },
  async del(url, body) {
    const r = await fetch(url, { method: 'DELETE', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body || {}) });
    const d = await r.json().catch(() => ({}));
    if (!r.ok) { if (r.status === 401 && d.needLogin) needLogin(); throw new Error(d.error || r.statusText); }
    return d;
  }
};

// 401（启用登录后未登录）→ 跳登录页（携带回跳地址；登录/分享页自身除外）
function needLogin() {
  const base = (location.hash || '#/').split('?')[0];
  if (base === '#/login' || base === '#/share') return;
  location.hash = `#/login?back=${encodeURIComponent(location.hash || '#/')}`;
}

import { reactive } from 'vue';
export const scopeStore = reactive({ organization_id: null, station_id: null, system_id: null, system_type: null, equipment_id: null, tree: null });

// ---------- 用户身份与权限（PRD 第四章） ----------
export const userStore = reactive({
  loaded: false,
  user: null,           // {username, displayName, role, freeLogin, share}
  loginEnabled: false   // 启用登录后：未登录 user=null
});
// 是否可写（admin/editor 且非分享身份）；为函数形式——import 的 ref 在模板中的解包行为不可靠（2026-10-16 Admin 页 isAdmin 恒真踩坑），函数调用最稳
export function canWrite() { return !!userStore.user && !userStore.user.share && (userStore.user.role === 'admin' || userStore.user.role === 'editor'); }
export function isAdmin() { return !!userStore.user && !userStore.user.share && userStore.user.role === 'admin'; }

export async function fetchMe() {
  try {
    const r = await api.get('/api/auth/me');
    userStore.user = r.user;
    userStore.loginEnabled = r.loginEnabled;
  } catch { userStore.user = null; }
  userStore.loaded = true;
}


